import { put, call, select, takeLatest } from 'redux-saga/effects';
import { couplingsAndBracketsActions } from '.';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  selectCustomerNumber,
  selectLanguageId,
} from 'app/features/erpSystem/slice/selectors';
import { erpalPayloadDTO } from '../../price/slice/utils';
import { selectErpSystem } from 'app/features/erpSystem/slice/selectors';
import { transformCouplingsAndBracketsDTO } from './utils';
import { setCouplingsPayload } from './types';
import { selectStoreId } from 'app/features/salesOrganisation/slice/selectors';

function* setCouplingsAndBrackets(action: PayloadAction<setCouplingsPayload>) {
  const { couplings, couplingPartNumber, bracketPartNumber } = action.payload;
  const { setCouplingSuccess, setCouplingFailure } =
    couplingsAndBracketsActions;

  try {
    if (couplings.length > 0) {
      const storeId = yield select(selectStoreId);

      let matchedCoupling = couplings.find(coupling => {
        return coupling.partNumber === couplingPartNumber;
      });
      let matchedBracket = matchedCoupling?.brackets.find(bracket => {
        return bracket.partNumber === bracketPartNumber;
      });

      if (matchedCoupling && matchedBracket) {
        const customerNumber = yield select(selectCustomerNumber);
        const languageId = yield select(selectLanguageId);
        const erpSystem = yield select(selectErpSystem);
        const couplingsAndBracketsTransformed = yield erpalPayloadDTO([
          matchedCoupling,
          matchedBracket,
        ]);

        const shopId = storeId % 10; // Get last digit of store id Ex: 100001  => 1

        const couplingsPriceResponse = yield call(
          fetch,
          `/valve-configurator/api/price?customerNumber=${customerNumber}&shopId=${shopId}&currency=EUR&languageId=${languageId}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(couplingsAndBracketsTransformed),
          },
        );
        const couplingsPrice = yield couplingsPriceResponse.json();

        const couplingsStockResponse = yield call(
          fetch,
          `/valve-configurator/api/stockStatus?erpSystem=${erpSystem}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(couplingsAndBracketsTransformed),
          },
        );
        const couplingsStockStatus = yield couplingsStockResponse.json();

        return yield put(
          setCouplingSuccess(
            transformCouplingsAndBracketsDTO(
              matchedCoupling,
              matchedBracket,
              couplingsPrice.items,
              couplingsStockStatus.items,
            ),
          ),
        );
      }
    }
    return yield put(setCouplingSuccess(null));
  } catch (e) {
    yield put(setCouplingFailure(e));
  }
}

export function* couplingsSaga() {
  yield takeLatest(
    couplingsAndBracketsActions.setCoupling.type,
    setCouplingsAndBrackets,
  );
}
